import React, { useContext } from 'react'
import { authContext } from './configurations/auth/authContext';
import RouterContainer from './components/RouterContainer';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import SideBar from './components/base/SideBar';

export default function Main() {
    const [isLogin, setIsLogin] = useContext(authContext);

    return (
        <HashRouter>
            {isLogin && <SideBar />}

            <RouterContainer />
        </HashRouter>
    )
}
